import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initThemeBeforeMount } from './lib/theme';
import './i18n';
import './index.css';

initThemeBeforeMount();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
